// import partner1 from "../../../../public/images/main-page/partners/partner1-v2-min.png";
import partner2 from "../../../../public/images/main-page/partners/partner2-min.png";
import partner3 from "../../../../public/images/main-page/partners/partner3-min.png";
import partner4 from "../../../../public/images/main-page/partners/partner4-min.png";
import partner6 from "../../../../public/images/main-page/partners/partner6-min.png";

export const partners = [partner2, partner3, partner4, partner6];
